export default "__VITE_ASSET__D1XW1oaP__"